import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f1ae0e98&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f1ae0e98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ae0e98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/BgUizHzZB/0/snt/info/info-customer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ae0e98')) {
      api.createRecord('f1ae0e98', component.options)
    } else {
      api.reload('f1ae0e98', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f1ae0e98&scoped=true&", function () {
      api.rerender('f1ae0e98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Broadcast/Detail/components/ListCard/index.vue"
export default component.exports